<template>
  <div
    class="col-12 px-3"
    style="border: none"
  >
    <form @submit.prevent="onSubmit" @reset="onReset">
      <div class="row nopads">
        <div class="row nopads">
          <div class="col-sm-6">
            <span class="search-title">{{ $t('ins_report.from_date') }}</span>
              <input
                id="from_date"
                v-model="fromDate"
                type="date"
                class="no-margin form-control form-control-sm"
              />
          </div>

          <div class="col-sm-6">
            <span class="search-title">{{ $t('ins_report.to_date') }}</span>
              <input
                id="to_date"
                v-model="toDate"
                type="date"
                class="form-control form-control-sm"
              />
          </div>
        </div>
      </div>
      <!-- User selection multiselect -->
      <div class="row">
        <div class="col-sm-6 pe-4">
          <span class="search-title">{{ $t('work_time.person') }}</span>
          <multiselect
            v-model="selectedUsers"
            class="multiselect_routa"
            :placeholder="$t('work_time.select_person')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="false"
            :multiple="true"
            label="name"
            track-by="name"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="users"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="col-sm-12 button-container">
          <button type="reset" class="btn btn-danger form-button">
              {{ $t('ins_report.clear') }}
          </button>
        <button type="submit" class="btn btn-primary form-button">
          {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import Multiselect from 'vue-multiselect'
import {timeUtils} from '../mixins/TimeUtils'
import {inject} from "vue";

export default {
    name: 'WorkdayDetailsSearch',
    components: {Multiselect},
    mixins: [restApi, timeUtils],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            users: [],
            selectedUsers: [],
            fromDate: '',
            toDate: '',
        }
    },
    mounted: function () {
        this.fetchUsers()
        if (!this.fromDate) {
            this.fromDate = this.timestampToDateInput(Date.now())
        }
        if (!this.toDate) {
            this.toDate = this.timestampToDateInput(Date.now())
        }
    },
    methods: {
        fetchUsers: function () {
            this.users = []
            this.restFetch(this.userUrl, this.handleUserResponse)
        },

        handleUserResponse: function (response) {
            if (response && response.data) {
                response.data.forEach(function (user) {
                    this.users.push({
                        value: user.id,
                        name: user.last_name + ', ' + user.first_name,
                        company: user.company ? user.company.name : '',
                        email: user.email
                    })
                }, this)
            }
            this.loading = false
        },

        onSubmit: function () {
            var params = {}
            if (this.selectedUsers.length > 0) {
                let results = []
                this.selectedUsers.forEach(function (item) {
                    results.push(item.value)
                }, this)
                params.users = results
            }
            if (this.fromDate.trim()) {
                params.from = this.fromDate
            } else {
                this.showAlert(this.$t('work_time.error_start_missing'))
                return null
            }
            if (this.toDate.trim()) {
                params.to = this.getEndOfTheDay(this.toDate).toISOString()
            } else {
                this.showAlert(this.$t('work_time.error_end_missing'))
                return null
            }
            params.time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone
            this.$emit('search', params)
        },

        onReset: function () {
            this.selectedUsers = []
        },

        resetTime: function () {
            this.year = new Date().getFullYear()
            this.month = new Date().getMonth() + 1
        }
    }
}
</script>


